// extracted by mini-css-extract-plugin
module.exports = {"Icon":"DetailsPage_Icon__A5RAM","Actions":"DetailsPage_Actions__IdMOQ"};